/* eslint-disable */
export default {
  eula: '최종 사용자 사용권 계약',
  eulaAbbr: 'EULA',
} as const;

// @key: @#@"eula"@#@ @source: @#@"End User License Agreement"@#@
// @key: @#@"eulaAbbr"@#@ @source: @#@"EULA"@#@
